import React from "react";

export default function MedicalPolicy({ name }) {
  return (
    <div>
      <h4 style={{ textAlign: "center" }}>Medical Declaration</h4>
      <p>
        On March 30, 1999, Transport Canada and the U.S. Federal Highway
        Administration (FHWA) entered into a reciprocal agreement regarding the
        physical requirements for a Canadian driver of a commercial vehicle in
        the U.S., as currently contained in the Federal Motor Carrier Safety
        Regulations, Part 391.41 et seq., and vice versa. The reciprocal
        agreement removes the requirement for a Canadian driver to carry a copy
        of a medical examiner's certificate indicating that the driver is
        physically qualified. (In effect, the existence of a valid driver's
        license issued by the Province of Ontario is deemed to be proof that a
        driver is physically qualified to drive in the U.S.). However, the FHWA
        will not recognize an Ontario driver's license if the driver has certain
        medical conditions, and those conditions would prohibit him from driving
        in the United States.
      </p>
      <p>
        I {name ? <b>{name}</b> : ""}, certify that I am qualified to operate a
        commercial motor vehicle in the United States. I further certify that:
      </p>
      <ul>
        <li>
          I have no clinical diagnosis of diabetes currently requiring insulin
          for control.
        </li>
        <li>
          I have no established medical history or clinical diagnosis of
          epilepsy.
        </li>

        <li>
          I do not have impaired hearing. (A driver must be able to perceive a
          forced whispered voice in the better ear at not less than 5 feet with
          or without the use of a hearing aid, or does not have an average
          hearing loss in the better ear greater than 40 decibels at 500Hz,
          1000Hz, or 2000Hz with or without a hearing aid when tested by an
          audiometric device calibrated to American National Standard Z24.5 -
          1951).
        </li>

        <li>
          I have not been issued a waiver by the Province of Ontario allowing me
          to operate a commercial motor vehicle pursuant to Section 20 or 21 of
          Ontario Regulation 340/94.
        </li>
      </ul>
      <p>
        I further agree to inform should my medical status change, or if I can
        no longer certify conditions as described above.
      </p>
    </div>
  );
}
